module.exports = __webpack_public_path__ + "img/package-02.66791691.png";